import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle2, BookOpen, PenTool, Brain, Calendar, MessageCircle, TrendingUp, ChevronLeft, ChevronRight } from "lucide-react";
import { useState } from "react";

const Index = () => {
  const [currentReviewIndex, setCurrentReviewIndex] = useState(0);
  const reviews = ["/images/Screen Shot 2025-12-26 at 07.29.18 AM.png", "/images/ChatGPT Image Dec 26, 2025, 04_27_46 PM.png"];
  
  const [currentWhatsAppIndex, setCurrentWhatsAppIndex] = useState(0);
  const whatsappImages = [
    "/images/WhatsApp Image 2025-12-26 at 07.55.01.jpeg",
    "/images/WhatsApp Image 2025-12-26 at 07.55.01 (1).jpeg",
    "/images/WhatsApp Image 2025-12-26 at 07.55.01 (2).jpeg",
    "/images/WhatsApp Image 2026-02-16 at 09.09.56.jpeg",
    "/images/WhatsApp Image 2026-02-16 at 09.10.52.jpeg"
  ];
  
  const nextReview = () => {
    setCurrentReviewIndex(prev => (prev + 1) % reviews.length);
  };
  
  const prevReview = () => {
    setCurrentReviewIndex(prev => (prev - 1 + reviews.length) % reviews.length);
  };
  
  const nextWhatsApp = () => {
    setCurrentWhatsAppIndex(prev => (prev + 1) % whatsappImages.length);
  };
  
  const prevWhatsApp = () => {
    setCurrentWhatsAppIndex(prev => (prev - 1 + whatsappImages.length) % whatsappImages.length);
  };

  return (
    <div className="bg-background">
      {/* Hero Section */}
      <div className="relative mx-3 sm:mx-7 mb-6 sm:mb-10 mt-4 sm:mt-7 rounded-2xl overflow-hidden">
        <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: `linear-gradient(to bottom, rgba(195, 213, 231, 0.95), rgba(161, 185, 215, 0.95)), url('/images/teen-boy-doing-homework.jpg')`,
          backgroundBlendMode: 'multiply'
        }} />
        
        {/* Header */}
        <div className="relative w-full flex flex-col sm:flex-row items-center justify-between px-4 sm:px-11 py-4 sm:py-6 z-10 gap-4 sm:gap-0">
          <div className="max-w-lg text-center sm:text-left">
            <div className="text-white text-sm sm:text-2xl font-bold uppercase mb-1 leading-tight sm:whitespace-nowrap">Persoonlijke bijles Engels voor havo en vwo</div>
            <div className="text-white text-2xl sm:text-5xl font-bold uppercase">TAAL MET VERTROUWEN</div>
          </div>
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-3 w-full sm:w-auto">
            <Button 
              variant="outline" 
              className="border-white text-white bg-transparent hover:bg-white/10 rounded-full px-4 sm:px-6 py-2 text-sm sm:text-base w-full sm:w-auto"
              onClick={() => document.getElementById('welcome-section')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Over Mij
            </Button>
            <Button 
              className="bg-[#7D9BCF] hover:bg-[#6B8AB5] text-white rounded-full px-4 sm:px-6 py-2 text-sm sm:text-base w-full sm:w-auto"
              onClick={() => window.open('https://wa.me/31639060219', '_blank')}
            >
              Gratis Kennismaking
            </Button>
          </div>
        </div>

        {/* Hero Content */}
        <div className="relative flex flex-col justify-center items-center sm:items-start z-10 px-4 py-8 sm:py-16 sm:pl-16">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 sm:p-8 max-w-3xl w-full">
            <h1 className="text-center sm:text-left text-white text-xl sm:text-3xl xl:text-4xl font-bold leading-tight mb-4">
              Gerichte bijles Engels met vertrouwen richting toetsen en examens.
            </h1>
            <p className="text-white/90 text-base sm:text-xl text-center sm:text-left mb-4">
              Gratis intake + persoonlijk leeradvies (PDF)
            </p>
            <div className="w-20 sm:w-32 h-px bg-white/40 mx-auto sm:mx-0 mb-4"></div>
            <p className="text-white/90 text-sm sm:text-lg text-center sm:text-left mb-2">
              Met persoonlijke online bijles & Asynchroon leren
            </p>
            <p className="text-white/80 text-xs sm:text-sm text-center sm:text-left italic">
              Omdat ik persoonlijk begeleid, werk ik met een beperkt aantal leerlingen per maand.
            </p>
          </div>
          
          <div className="mt-6 bg-white/90 backdrop-blur-sm rounded-xl p-3 italic text-center max-w-4xl w-full">
            <p className="text-[#5B7FA8] text-xs sm:text-sm">
              "Puur maatwerk: van onzeker naar sterke cijfers voor Engels." – Daniëlle - moeder van havo-leerling
            </p>
          </div>
        </div>

        {/* Bottom Info Bar */}
        <div className="relative mb-10 sm:mb-20 px-4 sm:px-6 py-3 sm:py-2 bg-white rounded-2xl sm:rounded-full flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 z-10 shadow-lg mx-auto max-w-fit">
          <div className="flex items-center gap-3 sm:gap-4 p-2 sm:p-4 min-w-0 sm:min-w-[250px] w-full sm:w-auto">
            <BookOpen className="w-5 h-5 sm:w-6 sm:h-6 text-[#7D9BCF] flex-shrink-0" />
            <div>
              <div className="text-neutral-400 text-xs sm:text-sm">Leesvaardigheid</div>
              <div className="text-neutral-900 text-sm sm:text-base font-medium">Examentraining</div>
            </div>
          </div>
          <div className="flex items-center gap-3 sm:gap-4 p-2 sm:p-4 min-w-0 sm:min-w-[250px] w-full sm:w-auto">
            <PenTool className="w-5 h-5 sm:w-6 sm:h-6 text-[#7D9BCF] flex-shrink-0" />
            <div>
              <div className="text-neutral-400 text-xs sm:text-sm">Schrijfvaardigheid</div>
              <div className="text-neutral-900 text-sm sm:text-base font-medium">Overtuigend schrijven</div>
            </div>
          </div>
          <div className="flex items-center gap-3 sm:gap-4 p-2 sm:p-4 min-w-0 sm:min-w-[250px] w-full sm:w-auto">
            <Brain className="w-5 h-5 sm:w-6 sm:h-6 text-[#7D9BCF] flex-shrink-0" />
            <div>
              <div className="text-neutral-400 text-xs sm:text-sm">Grammatica</div>
              <div className="text-neutral-900 text-sm sm:text-base font-medium">Regels toepassen</div>
            </div>
          </div>
        </div>
      </div>

      {/* Quote Section */}
      <div className="mx-3 sm:mx-7 my-8 sm:my-16">
        <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-4 sm:p-8 shadow-xl max-w-4xl mx-auto">
          <p className="text-[#4A6B8A] text-base sm:text-2xl italic text-center leading-relaxed">
            "De cijfers zijn verbeterd, maar belangrijker: het zelfvertrouwen is terug." — ouder van een vwo-leerling
          </p>
        </div>
      </div>

      {/* Welcome Section */}
      <div id="welcome-section" className="mx-3 sm:mx-7 px-4 sm:px-12 py-8 sm:py-12 bg-gradient-to-r from-[#4A6B8A] to-[#5B7FA8] rounded-2xl mb-6 sm:mb-10">
        <h2 className="text-white text-2xl sm:text-4xl font-bold text-center mb-6 sm:mb-10">Welkom — Ik help leerlingen echt vooruit</h2>
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-8">
          {/* Column 1 - About */}
          <div className="bg-white/10 rounded-xl p-6 backdrop-blur-sm">
            <h3 className="text-white text-lg sm:text-xl font-bold mb-3 sm:mb-4">Over mij</h3>
            <p className="text-white/90 text-sm sm:text-base leading-relaxed">
              Deze persoonlijke bijles middelbare school is geschikt voor leerlingen die vastlopen bij Engels op havo of vwo.<br/><br/>
              Met persoonlijke één-op-één bijles werk ik doelgericht aan de taalonderwerpen die op dit moment centraal staan, altijd met het oog op de komende toets.<br/><br/>
              Daarbij besteed ik gerichte aandacht aan de specifieke pijnpunten van de leerling, zodat uitleg, oefenen en feedback precies aansluiten bij wat nodig is.<br/><br/>
              Geen standaard bijles, maar maatwerk dat past bij het niveau, het tempo en de exameneisen van havo en vwo.<br/>
              Omdat ik persoonlijk begeleid, werk ik met een beperkt aantal leerlingen per maand.
            </p>
          </div>

          {/* Column 2 - Photo & Contact */}
          <div className="bg-white/10 rounded-xl p-4 sm:p-6 backdrop-blur-sm flex flex-col items-center">
            <img src="/images/Screen Shot 2024-10-16 at 18.00.19 PM.png" alt="Maurice Jeths" className="w-48 sm:w-72 h-auto rounded-xl shadow-lg mb-2" />
            <p className="text-white text-base sm:text-lg font-bold mb-3 sm:mb-4">Maurice Jeths</p>
            <div className="text-center space-y-2">
              <p className="text-white/90 text-xs sm:text-sm">Bijlesdocent Engels</p>
              <p className="text-white/80 text-xs">8+ jaar ervaring<br />Gespecialiseerd in examengerichte bijles Engels voor havo en vwo, met focus op leesvaardigheid, schrijven en grammatica.</p>
            </div>
          </div>

          {/* Column 3 - Quote & Contact */}
          <div className="space-y-3 sm:space-y-4">
            <div className="bg-white/10 rounded-xl p-4 sm:p-6 backdrop-blur-sm">
              <p className="text-white text-sm sm:text-base italic leading-relaxed">
                "Ik weet hoe frustrerend het is als een kind zijn zelfvertrouwen verliest – daar help ik dagelijks bij."
              </p>
            </div>
            
            <div className="bg-[#C3D5E7] rounded-xl p-3 sm:p-4 flex items-center gap-2 sm:gap-3">
              <img src="/images/WhatsApp Image 2025-12-26 at 06.57.59.jpeg" alt="WhatsApp QR Code" className="w-12 h-12 sm:w-16 sm:h-16 rounded-lg flex-shrink-0" />
              <div className="text-xs sm:text-sm">
                <p className="text-[#4A6B8A] font-semibold">Tel/WhatsApp 06 3906 0219</p>
                <p className="text-[#4A6B8A] text-xs">Startmoment elke maand – plan nu een gesprek.</p>
              </div>
            </div>
            
            {/* Extra QR Code */}
            <div className="flex justify-center">
              <div className="bg-white/10 rounded-xl p-3 sm:p-4 backdrop-blur-sm">
                <img 
                  src="/images/Screen Shot 2026-02-16 at 09.40.00 AM.png" 
                  alt="WhatsApp QR Code" 
                  className="w-24 h-24 sm:w-32 sm:h-32 rounded-lg cursor-pointer sm:cursor-default hover:scale-105 sm:hover:scale-100 transition-transform duration-300" 
                  onClick={() => {
                    if (window.innerWidth < 640) {
                      window.open('https://wa.me/31639060219', '_blank');
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Wat is Asynchroon leren Section */}
      <div className="mx-3 sm:mx-20 my-8 sm:my-16">
        <h2 className="text-neutral-800 text-2xl sm:text-5xl font-semibold mb-8 sm:mb-12 text-center sm:text-left">Wat is Asynchroon leren?</h2>
        <div className="grid grid-cols-1 gap-4 sm:gap-8">
          <Card className="border-2 border-[#C3D5E7] hover:shadow-lg transition-all duration-300">
            <CardContent className="p-4 sm:p-8">
              <div className="w-12 h-12 bg-[#7D9BCF] rounded-full flex items-center justify-center mb-4">
                <Calendar className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-lg sm:text-2xl font-semibold mb-3">Flexibiliteit</h3>
              <p className="text-neutral-600 text-sm sm:text-base">
                Leren op jouw eigen tempo en tijdstip. Geen vaste roosters, maar wel structuur en begeleiding wanneer je het nodig hebt.
              </p>
            </CardContent>
          </Card>
          <Card className="border-2 border-[#C3D5E7] hover:shadow-lg transition-all duration-300">
            <CardContent className="p-4 sm:p-8">
              <div className="w-12 h-12 bg-[#7D9BCF] rounded-full flex items-center justify-center mb-4">
                <MessageCircle className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-lg sm:text-2xl font-semibold mb-3">Persoonlijke Feedback</h3>
              <p className="text-neutral-600 text-sm sm:text-base">
                Naast de wekelijkse online les krijgt de leerling 2 gerichte opdrachten per week. Na 5 uur persoonlijke feedback.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>

      {/* WhatsApp Testimonials Section */}
      <div className="mx-3 sm:mx-7 my-8 sm:my-16 py-8 sm:py-12 bg-gradient-to-r from-[#4A6B8A] to-[#5B7FA8] rounded-2xl">
        <div className="px-4 sm:px-12">
          <h2 className="text-white text-xl sm:text-4xl font-semibold mb-4 text-center">Snellere leerwinst met wekelijkse maatwerkopdrachten </h2>
          <p className="text-white/90 text-sm sm:text-lg text-center mb-6 sm:mb-8">Voorbeelden van wekelijkse feedback en maatwerkopdrachten in de praktijk.</p>
          {/* Mobile Carousel */}
          <div className="block sm:hidden">
            <div className="relative">
              <div className="flex justify-center items-center gap-4 mb-4">
                <button onClick={prevWhatsApp} className="bg-white/20 hover:bg-white/30 text-white p-2 rounded-full shadow-lg transition-all duration-300" aria-label="Vorige WhatsApp bericht">
                  <ChevronLeft className="w-5 h-5" />
                </button>
                <div className="bg-white rounded-xl p-4 shadow-lg max-w-xs w-full">
                  <img src={whatsappImages[currentWhatsAppIndex]} alt={`WhatsApp bericht ${currentWhatsAppIndex + 1}`} className="w-full h-auto rounded-lg" />
                </div>
                <button onClick={nextWhatsApp} className="bg-white/20 hover:bg-white/30 text-white p-2 rounded-full shadow-lg transition-all duration-300" aria-label="Volgende WhatsApp bericht">
                  <ChevronRight className="w-5 h-5" />
                </button>
              </div>
              <div className="flex justify-center gap-2">
                {whatsappImages.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentWhatsAppIndex(index)}
                    className={`w-2 h-2 rounded-full transition-all duration-300 ${
                      index === currentWhatsAppIndex ? 'bg-white' : 'bg-white/40'
                    }`}
                    aria-label={`Ga naar WhatsApp bericht ${index + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
          
          {/* Desktop Grid */}
          {/* Desktop Grid - 5 individual items */}
          <div className="hidden sm:grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            <div className="bg-white rounded-xl p-4 shadow-lg hover:scale-105 transition-transform duration-300">
              <img src="/images/WhatsApp Image 2025-12-26 at 07.55.01.jpeg" alt="WhatsApp bericht 1" className="w-full h-auto rounded-lg" />
            </div>
            <div className="bg-white rounded-xl p-4 shadow-lg hover:scale-105 transition-transform duration-300">
              <img src="/images/WhatsApp Image 2025-12-26 at 07.55.01 (1).jpeg" alt="WhatsApp bericht 2" className="w-full h-auto rounded-lg" />
            </div>
            <div className="bg-white rounded-xl p-4 shadow-lg hover:scale-105 transition-transform duration-300">
              <img src="/images/WhatsApp Image 2025-12-26 at 07.55.01 (2).jpeg" alt="WhatsApp bericht 3" className="w-full h-auto rounded-lg" />
            </div>
            <div className="bg-white rounded-xl p-4 shadow-lg hover:scale-105 transition-transform duration-300">
              <img src="/images/WhatsApp Image 2026-02-16 at 09.09.56.jpeg" alt="WhatsApp bericht 4" className="w-full h-auto rounded-lg" />
            </div>
            <div className="bg-white rounded-xl p-4 shadow-lg hover:scale-105 transition-transform duration-300">
              <img src="/images/WhatsApp Image 2026-02-16 at 09.10.52.jpeg" alt="WhatsApp bericht 5" className="w-full h-auto rounded-lg" />
            </div>
          </div>
        </div>
      </div>

      {/* Meer Inzicht Section */}
      <div className="mx-3 sm:mx-20 my-8 sm:my-16">
        <h2 className="text-neutral-800 text-2xl sm:text-5xl font-semibold mb-6 sm:mb-8 text-center sm:text-left">Meer inzicht in de stof</h2>
        <div className="grid grid-cols-1 gap-4 sm:gap-8">
          <Card className="border-2 border-[#C3D5E7] hover:shadow-lg transition-all duration-300">
            <CardContent className="p-4 sm:p-8">
              <h3 className="text-lg sm:text-2xl font-semibold mb-4 text-[#7D9BCF]">Hoe werkt het?</h3>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-[#7D9BCF] text-white rounded-full flex items-center justify-center flex-shrink-0 font-semibold">1</div>
                  <div>
                    <p className="font-semibold text-neutral-800">Wekelijkse online les</p>
                    <p className="text-neutral-600 text-sm">De begeleiding bestaat uit online bijles Engels, altijd één-op-één via videobellen, zodat uitleg en feedback persoonlijk blijven.</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-[#7D9BCF] text-white rounded-full flex items-center justify-center flex-shrink-0 font-semibold">2</div>
                  <div>
                    <p className="font-semibold text-neutral-800">2 wekelijkse maatwerkopdrachten</p>
                    <p className="text-neutral-600 text-sm">Gerichte oefeningen afgestemd op jouw niveau</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-[#7D9BCF] text-white rounded-full flex items-center justify-center flex-shrink-0 font-semibold">3</div>
                  <div>
                    <p className="font-semibold text-neutral-800">Feedback binnen 5 uur</p>
                    <p className="text-neutral-600 text-sm">Persoonlijke uitleg en tips voor verbetering. (Dit kan via een voicebericht, een uitgewerkt document met suggesties en tips, en ondersteunend oefenmateriaal om sneller verder te komen.)</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-[#7D9BCF] text-white rounded-full flex items-center justify-center flex-shrink-0 font-semibold">4</div>
                  <div>
                    <p className="font-semibold text-neutral-800">Voortgangsrapportage</p>
                    <p className="text-neutral-600 text-sm">Regelmatige updates over de ontwikkeling</p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
          <Card className="border-2 border-[#C3D5E7] hover:shadow-lg transition-all duration-300">
            <CardContent className="p-4 sm:p-8">
              <h3 className="text-lg sm:text-2xl font-semibold mb-4 text-[#7D9BCF]">Wat maakt het anders?</h3>
              <div className="space-y-6">
                <div>
                  <h4 className="font-semibold text-neutral-800 mb-2">Persoonlijke aanpak</h4>
                  <p className="text-neutral-600 text-sm">Elke leerling is uniek. Daarom krijg je een persoonlijk leerplan dat aansluit bij jouw niveau en leerdoelen.</p>
                </div>
                <div>
                  <h4 className="font-semibold text-neutral-800 mb-2">Flexibele planning</h4>
                  <p className="text-neutral-600 text-sm">Lessen en opdrachten passen in jouw agenda. Geen stress over vaste tijden.</p>
                </div>
                <div>
                  <h4 className="font-semibold text-neutral-800 mb-2">Snelle feedback</h4>
                  <ul className="text-neutral-600 text-sm space-y-1">
                    <li>• Binnen 5 uur reactie op opdrachten</li>
                    <li>• Concrete tips voor verbetering</li>
                    <li>• Uitleg via audio, tekst of video</li>
                  </ul>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>

      {/* Resultaten Section */}
      <div className="mx-3 sm:mx-7 my-8 sm:my-16 py-8 sm:py-16 bg-gradient-to-r from-[#4A6B8A] to-[#5B7FA8] rounded-2xl">
        <div className="px-12">
          <h2 className="text-white text-2xl sm:text-5xl font-semibold mb-6 sm:mb-8 text-center sm:text-left">Wat levert het op?</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
            {["Meer inzicht in de stof", "Hogere cijfers", "Meer zelfvertrouwen", "Betere studievaardigheden", "Minder stress rond Engels", "Meer zelfstandigheid"].map((item, index) => <div key={index} className="flex items-center gap-3">
                <CheckCircle2 className="w-6 h-6 text-white flex-shrink-0" />
                <span className="text-white text-lg">{item}</span>
              </div>)}
          </div>
        </div>
      </div>

      {/* Voor wie Section */}
      <div className="mx-3 sm:mx-20 my-8 sm:my-16">
        <h2 className="text-neutral-800 text-2xl sm:text-5xl font-semibold mb-6 sm:mb-8 text-center sm:text-left">Voor wie?</h2>
        <Card className="border-2 border-[#C3D5E7]">
          <CardContent className="p-4 sm:p-8">
            <p className="text-lg text-neutral-700 mb-6">
              Voor havo- en vwo-leerlingen:
            </p>
            <div className="grid grid-cols-1 gap-3 sm:gap-4">
              {["Die extra ondersteuning zoeken bij Engels richting toetsen en examens", "Moeite hebben met Engels", "Gemotiveerd zijn om te groeien", "Baat hebben bij persoonlijke bijles"].map((item, index) => <div key={index} className="flex items-center gap-3">
                  <CheckCircle2 className="w-5 h-5 text-[#7D9BCF] flex-shrink-0" />
                  <span className="text-neutral-700">{item}</span>
                </div>)}
            </div>
          </CardContent>
        </Card>
      </div>

      {/* CTA Section */}
      <div className="mx-3 sm:mx-7 my-8 sm:my-16">
        <div className="relative rounded-2xl bg-gradient-to-r from-[#4A6B8A] to-[#5B7FA8] py-8 sm:py-16 px-4 sm:px-20 flex flex-col sm:flex-row items-center gap-6 sm:justify-between">
          <div className="max-w-2xl text-center sm:text-left">
            <h2 className="text-white text-xl sm:text-3xl font-semibold mb-4">Plan een gratis kennismakingsgesprek en bekijk of dit past bij jouw kind</h2>
            <p className="text-white text-sm sm:text-lg mb-6 sm:mb-8">
              In het gratis kennismakingsgesprek krijg je inzicht in waar je kind vastloopt en wat nu nodig is richting de komende toets.
            </p>
            <Button 
              size="lg" 
              className="bg-white text-[#7D9BCF] hover:bg-white/90 rounded-full px-6 sm:px-8 py-4 sm:py-6 text-base sm:text-lg font-semibold w-full sm:w-auto"
              onClick={() => window.open('https://wa.me/31639060219', '_blank')}
            >
              Plan een Gesprek
            </Button>
          </div>
          <div className="flex justify-center">
            <div className="text-center">
              <img src="/images/WhatsApp Image 2025-12-26 at 06.57.59.jpeg" alt="WhatsApp QR Code" className="w-32 h-32 sm:w-48 sm:h-48 rounded-xl shadow-lg hover:scale-105 transition-transform duration-300 mb-3" />
              <img src="/images/MJ.png" alt="Maurice Jeths" className="w-32 h-32 sm:w-48 sm:h-48 rounded-xl shadow-lg hover:scale-105 transition-transform duration-300 mb-3 object-cover" />
              <p className="text-white text-sm sm:text-lg font-semibold">Maurice Jeths | bijlesdocent</p>
            </div>
          </div>
        </div>
      </div>

      {/* Review Section */}
      <div className="mx-3 sm:mx-20 my-8 sm:my-16">
        <p className="text-neutral-600 text-sm sm:text-lg text-center mb-4 sm:mb-6">Ouders van havo- en vwo-leerlingen delen hun ervaring met mijn online bijles Engels</p>
        <h2 className="text-neutral-800 text-2xl sm:text-5xl font-semibold mb-6 sm:mb-8 text-center">Reviews</h2>
        <div className="flex justify-center items-center gap-2 sm:gap-4">
          <button onClick={prevReview} className="bg-[#7D9BCF] hover:bg-[#6B8AB5] text-white p-3 rounded-full shadow-lg transition-all duration-300 hover:scale-110" aria-label="Vorige review">
            <ChevronLeft className="w-6 h-6" />
          </button>
          <div className="bg-white rounded-2xl shadow-xl p-4 sm:p-8 max-w-4xl relative">
            <img src={reviews[currentReviewIndex]} alt={`Review ${currentReviewIndex + 1}`} className="w-full h-auto rounded-lg" />
          </div>
          <button onClick={nextReview} className="bg-[#7D9BCF] hover:bg-[#6B8AB5] text-white p-3 rounded-full shadow-lg transition-all duration-300 hover:scale-110" aria-label="Volgende review">
            <ChevronRight className="w-6 h-6" />
          </button>
        </div>
        <div className="flex justify-center mt-6 gap-2">
          {reviews.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentReviewIndex(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                index === currentReviewIndex ? 'bg-[#7D9BCF]' : 'bg-neutral-300'
              }`}
              aria-label={`Ga naar review ${index + 1}`}
            />
          ))}
        </div>
      </div>

      <footer className="mx-3 sm:mx-20 py-8 sm:py-16 border-t border-neutral-200">
        <div className="text-center">
          <p className="text-2xl sm:text-4xl font-bold text-neutral-800 mb-2 uppercase text-center sm:text-left">TAAL MET VERTROUWEN</p>
          <h3 className="text-xl sm:text-2xl font-bold text-neutral-800 mb-3 sm:mb-4">Bijles Engels</h3>
          <p className="text-neutral-600 text-sm sm:text-base mb-4 sm:mb-6">Persoonlijke online bijles voor voortgezet onderwijs</p>
          <Button 
            size="lg" 
            className="bg-[#7D9BCF] hover:bg-[#6B8AB5] text-white rounded-full px-6 sm:px-8 py-4 sm:py-6 text-base sm:text-lg font-semibold w-full sm:w-auto max-w-xs sm:max-w-none"
            onClick={() => window.open('https://wa.me/31639060219', '_blank')}
          >
            Plan een Gesprek
          </Button>
          <p className="text-neutral-500 text-xs sm:text-sm mt-4">© 2025 Alle rechten voorbehouden</p>
        </div>
      </footer>
    </div>
  );
};

export default Index;